<template>
	<label
		:for="checkboxId"
		class="custom-checkbox"
		:class="{ checked: isOn, disabled: disabled, enabled: !disabled }"
		:aria-label="checkboxDescription"
	>
		<span
			class="custom-checkmark"
			:class="{ disabled: disabled, enabled: !disabled }"
			role="checkbox"
			:aria-checked="isChecked"
			tabindex="0"
			:aria-labelledby="checkboxId"
		>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 8.95">
				<title>check</title>
				<path
					d="M4.08,8.77.18,4.87A.59.59,0,0,1,.18,4L1,3.18a.59.59,0,0,1,.85,0L4.5,5.8,10.13.18a.59.59,0,0,1,.85,0l.84.84a.59.59,0,0,1,0,.85l-6.9,6.9a.58.58,0,0,1-.84,0Z"
				/>
			</svg>
		</span>
	</label>
</template>

<script>
export default {
	name: 'Checkbox',
	// TODO: Will be refactored, props shouldn't be mutated, this is setting up to make switch over to using vuex a bit easier
	props: {
		isChecked: Boolean,
		checkboxId: String,
		checkboxDescription: String,
		disabled: Boolean,
	},
	data() {
		return {
			selected: this.isChecked,
		};
	},
	computed: {
		isOn: {
			get() {
				return this.selected;
			},
			set(value) {
				this.selected = value;
			},
		},
	},
	watch: {
		isChecked(newValue) {
			this.isOn = newValue;
		},
	},
};
</script>

<style lang="scss" scoped>
.hidden-checkbox {
	width: 100%;
	height: 100%;
	opacity: 0;
	position: absolute;
	margin: 0;
	z-index: 10;

	&:checked {
		& + .custom-checkmark svg {
			fill: $white;
		}
	}
}

.lendwize-product-form {
	.custom-checkbox {
		&.enabled {
			&.checked {
				background: $brand-teal;
			}
		}
	}
}

.custom-checkbox {
	@include rem('width', 18px);
	@include rem('height', 18px);
	position: relative;
	display: inline-block;
	box-shadow: inset 0 0 0 $b360-border-width-thin $border-color-light;
	border-radius: $b360-border-radius-base;
	background-color: transparent;
	transition: $b360-motion-selection;

	&.enabled {
		cursor: pointer;

		&::before {
			background-color: $brand-blue;
			box-shadow: unset;
		}

		&.checked {
			background: $brand-blue;

			&.disabled {
				cursor: not-allowed;

				&::before {
					background-color: $b360-color--gray__darker;
					box-shadow: unset;
				}
			}

			svg {
				@include rem('width', 12px);
				@include rem('height', 12px);
				fill: $white;
				transition: fill $b360-motion-duration--shorter
					$b360-motion-easing--accelerate;
			}
		}
	}

	&.disabled {
		cursor: not-allowed;

		&::before {
			background-color: $b360-color--gray__darker;
			box-shadow: unset;
		}
	}

	.custom-checkmark {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0;
		opacity: 0;

		svg {
			@include rem('width', 12px);
			@include rem('height', 13px);
			fill: transparent;
			transition: fill $b360-motion-duration--shorter
				$b360-motion-easing--accelerate;
		}
	}

	&.checked .custom-checkmark {
		opacity: 1;
	}
}

.alert-layout-content
	.target-comp--checkbox#target-comp-checkbox.checked.disabled,
.alert-layout-content
	.target-comp--checkbox#target-comp-checkbox.disabled:hover {
	background-color: $b360-color--gray__darker;
	box-shadow: unset;
}
</style>
